import { useState } from 'react';

import styles from './FaqScreenshot.module.css';

interface FaqScreenshotProps {
  src: string;
  alt: string;
}

// PARA-133 (AC-4, AC-E1, AC-16) — иллюстрация ответа.
//
// loading="lazy": кадр запрашивается только когда статью раскрыли, поэтому
// пользователь, не открывший справку, не платит за 44 PNG вовсе.
//
// AC-E1: при ошибке загрузки компонент убирает СЕБЯ целиком — ни «битой»
// иконки, ни рамки, ни зарезервированного пустого места. Текст ответа при этом
// остаётся полностью читаемым: изображение — дополнение, а не носитель смысла.
export function FaqScreenshot({ src, alt }: FaqScreenshotProps): JSX.Element | null {
  const [hasFailed, setHasFailed] = useState(false);

  if (hasFailed) {
    return null;
  }

  return (
    <img
      className={styles.image}
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setHasFailed(true)}
    />
  );
}
